<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-center bg-no-repeat"
    :style="bannerStyle"
  >
    <div class="container-wrap flex h-mobile-banner py-2 tablet:h-banner">
      <div class="flex w-full flex-col items-center justify-center">
        <div class="text-center">
          <h2 class="text-h1 banner-title mb-2 text-blue-400">
            {{ t('title') }}
          </h2>
          <p class="banner-description is-mobile-hidden mb-3">
            {{ t('description') }}
          </p>
        </div>
        <TheButton
          v-if="!isLogin"
          :id="isCN ? 'tracking_login' : undefined"
          :title="t('item-button')"
          class="w-[180px]"
          @click="handleClick"
        >
          <span class="text-sm">{{ t('item-button') }}</span>
        </TheButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const router = useRouter();
  const { t, locale } = useI18n({ useScope: 'local' });
  const { isJP, isCN } = useLanguage();
  const { blobDomain } = useWebsite();

  const profileStore = useProfileStore();
  const { isLogin } = storeToRefs(profileStore);

  const bannerStyle = computed((): string => {
    return `background-image: url(${blobDomain.value}/wise-paas-marketplace/contact-us/contact-us_banner-02.webp)`;
  });

  const handleClick = (): void => {
    window.gtag('event', 'site_click', { Item: 'FreeSignUp' });

    if (isJP.value) {
      router.push(
        `/${locale.value}/marketplace/help/sales-support?IssueType=0`
      );
      return;
    }

    const fullUrl: string = window.location.origin;
    const callbackUrl: string = `${fullUrl}/${locale.value}/marketplace`;
    profileStore.HANDLE_LOGIN(callbackUrl);
  };
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Get started with an WISE free account",
    "description": "Get free online training with certification and try our selected products for free for 30 days.",
    "item-button": "Free Sign Up"
  },
  "en-jp": {
    "title": "Get started with an WISE free account",
    "description": "Get free online training with certification and try our selected products for free for 30 days.",
    "item-button": "Free Sign Up"
  },
  "en-tw": {
    "title": "Get started with an WISE free account",
    "description": "Get free online training with certification and try our selected products for free for 30 days.",
    "item-button": "Free Sign Up"
  },
  "en-kr": {
    "title": "Get started with an WISE free account",
    "description": "Get free online training with certification and try our selected products for free for 30 days.",
    "item-button": "Free Sign Up"
  },
  "en-americas": {
    "title": "Get started with an WISE free account",
    "description": "Get free online training with certification and try our selected products for free for 30 days.",
    "item-button": "Free Sign Up"
  },
  "en-asia-pacific": {
    "title": "Get started with an WISE free account",
    "description": "Get free online training with certification and try our selected products for free for 30 days.",
    "item-button": "Free Sign Up"
  },
  "en-emea": {
    "title": "Get started with an WISE free account",
    "description": "Get free online training with certification and try our selected products for free for 30 days.",
    "item-button": "Free Sign Up"
  },
  "ja-jp": {
    "title": "無料で WISE メンバーになる",
    "description": "無料で WISE メンバーになる",
    "item-button": "無料登録"
  },
  "zh-cn": {
    "title": "免费成为WISE-Marketplace会员",
    "description": "获得免费的线上认证培训，并免费试用我们精选的产品 30 天",
    "item-button": "免费注册"
  },
  "zh-tw": {
    "title": "立即建立 WISE 免費帳號",
    "description": "獲得免費的線上認證培訓，並免費試用我們精選的產品 30 天",
    "item-button": "免費註冊"
  }
}
</i18n>
